import { jsonGet, jsonPost, jsonPatch, jsonDelete } from "../api";

export const fetchDossiers = async (brandId) =>
  jsonGet(`research/dossiers?brandId=${brandId}`);

export const fetchDossier = async (dossierId) =>
  jsonGet(`research/dossiers/${dossierId}`);

// 404 is the normal answer for a workstream nobody has researched yet — research
// costs money, so opening a drawer must never start it. Null keeps that out of the
// caller's error path.
export const fetchDossierForWorkstream = async (planId, workstreamId, country, language) => {
  try {
    const params = new URLSearchParams({ planId, workstreamId });
    if (country) params.set("country", country);
    if (language) params.set("language", language);
    return await jsonGet(`research/dossiers/by-workstream?${params.toString()}`);
  } catch {
    return null;
  }
};

export const fetchWorkstreamEditions = async (planId, workstreamId) => {
  try {
    return await jsonGet(
      `research/dossiers/by-workstream/editions?planId=${planId}&workstreamId=${workstreamId}`
    );
  } catch {
    return [];
  }
};

export const startResearch = async (payload) =>
  jsonPost("research/dossiers", payload);

export const refreshDossier = async (dossierId) =>
  jsonPost(`research/dossiers/${dossierId}/refresh`);

export const cancelResearch = async (dossierId) =>
  jsonPost(`research/dossiers/${dossierId}/cancel`);

export const deleteDossier = async (dossierId) =>
  jsonDelete(`research/dossiers/${dossierId}`);

export const proposeIdeasFromResearch = async (planId, workstreamId, count, dossierId) =>
  jsonPost("research/dossiers/propose-ideas", {
    contentPlanId: planId,
    workstreamId,
    count,
    dossierId,
  });

export const addPrimaryMaterial = async (dossierId, text, suggestionId) =>
  jsonPost(`research/dossiers/${dossierId}/material`, { text, suggestionId });

export const removePrimaryMaterial = async (dossierId, contributionId) =>
  jsonDelete(`research/dossiers/${dossierId}/material/${contributionId}`);

export const updateSuggestion = async (dossierId, suggestionId, status) =>
  jsonPatch(`research/dossiers/${dossierId}/suggestions/${suggestionId}`, {
    status,
  });

export const dismissClaim = async (dossierId, claimId) =>
  jsonDelete(`research/dossiers/${dossierId}/claims/${encodeURIComponent(claimId)}`);
